import React from 'react'

interface StockUnavailableLightboxProps {
	isOpen: boolean
	title: string
	message: string
	items: string[]
	removedFromBasket?: boolean
	onClose: () => void
}

const StockUnavailableLightbox: React.FC<StockUnavailableLightboxProps> = ({
	isOpen,
	title,
	message,
	items,
	removedFromBasket = false,
	onClose
}) => {
	if (!isOpen) {
		return null
	}

	return (
		<div
			className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm px-4"
			onMouseDown={(event) => event.stopPropagation()}
			onClick={onClose}
		>
			<div
				className="w-full max-w-lg rounded-2xl bg-white p-8 shadow-xl"
				onMouseDown={(event) => event.stopPropagation()}
				onClick={(event) => event.stopPropagation()}
			>
				<div className="flex flex-col gap-4">
					<div className="flex flex-col gap-2">
						<h2 className="text-2xl font-medium text-gray-900">{title}</h2>
						<p className="text-gray-600">{message}</p>
						{removedFromBasket && (
							<p className="text-sm text-gray-500">
								We removed these items from your basket so you are not charged for unavailable items.
							</p>
						)}
					</div>

					{items.length > 0 && (
						<ul className="list-disc pl-5 text-sm text-gray-700">
							{items.map(item => (
								<li key={item}>{item}</li>
							))}
						</ul>
					)}

					<button
						onClick={onClose}
						className="w-full rounded-full bg-orange px-6 py-3 font-medium text-white transition-colors hover:bg-orange/90"
					>
						Okay, I understand
					</button>
				</div>
			</div>
		</div>
	)
}

export default StockUnavailableLightbox
